import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { AddShoppingCartItemsForChildAccountsRequest, ChildUserAccountDto, ProductDto } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { ShoppingCartService } from 'src/app/core/services/shopping-cart.service';

@Component({
  selector: 'app-product-preview',
  templateUrl: './product-preview.component.html',
  styleUrls: ['./product-preview.component.scss']
})
export class ProductPreviewComponent implements OnInit, OnDestroy {

  @Input() product: ProductDto;
  @Input() isBusinessAccount: boolean;
  @Input() isRegFlow: boolean;
  @Output() addItem: EventEmitter<number> = new EventEmitter();
  @Output() download: EventEmitter<ProductDto> = new EventEmitter();
  pdfUrl: string;

  accountSubscription: Subscription;
  batchAddSubscription: Subscription;
  childAccounts: ChildUserAccountDto[];
  canBuyForChild: boolean;

  constructor(
    private configHelper: ConfigHelper,
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
    private shoppingCartService: ShoppingCartService,
    private router: Router,
    private toastService: HotToastService,
  ) { }

  ngOnInit(): void {
    this.pdfUrl = this.configHelper.getPdfUrl(this.product.pdfUrl);
    if (this.isBusinessAccount) {
      //check for child accounts
      this.accountSubscription = this.accountService.getBusinessAccount()
        .subscribe(x => {
          this.childAccounts = x.content.childUserAccounts;
          if (this.childAccounts.length > 0) {
            this.canBuyForChild = true;
          }
          else {
            this.canBuyForChild = false;
          }
        });
    }

  }
  onAddItemToCart(productId: number) {
    this.addItem.emit(productId);
    this.activeModal.close();
  }

  onContinue() {
    this.activeModal.close();
  }

  onBatchAddItemToCart(selectedChildAccountsIds: number[]) {
    const addShoppingCartItemsForChildAccountsRequest: AddShoppingCartItemsForChildAccountsRequest = {
      childAccountIds: selectedChildAccountsIds,
      discountCodeId: this.product.discountCodeId,
      productId: this.product.id
    };
    this.batchAddSubscription = this.shoppingCartService.batchAddItem(addShoppingCartItemsForChildAccountsRequest)
      .subscribe(
        result => {
          this.shoppingCartService.setShoppingCart(result);
          this.activeModal.close();
          if (this.isRegFlow) {
            this.router.navigate(['/registration/order-summary']);
          }
          else {
            this.router.navigate(['/shopping-cart']);
          }
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
          else {
            this.toastService.warning('Unable to add item to cart');
          }
          this.activeModal.close();
        }
      );
  }

  downloadProductFile = (product: ProductDto) => {
    this.download.emit(product);
    this.activeModal.close();
  };

  ngOnDestroy(): void {
    this.accountSubscription?.unsubscribe();
  }

}
